import TableFormat from 'components/TableFormat';
export const SalesDetails = ({ formDefaultData }: any) => {
  return <TableFormat width="30%" size="medium" title="" data={formDefaultData} />;
};
